export default {
    gain: "Whole Milk",
    lose: "1% Milk",
    maintain: "2% Milk"
}